import { gql } from '@apollo/client';

const HOLTER_EVENT_INDEX_QUERY = gql`
  query holterEventIndex($filter: HolterEventIndexFilter!) {
    holterEventIndex(filter: $filter) {
      isSuccess
      message
      eventIndex
    }
  }
`;

export default HOLTER_EVENT_INDEX_QUERY;
